import styles from './Performance.module.scss';
import { useTranslation } from 'react-i18next';
import { NavTabs } from '@cas/components/tabs/nav-tabs/NavTabs';
import Page from '@customer/templates/page/Page';
import { Outlet } from 'react-router-dom';
import { QueryTag } from '@customer/store/api';
import { AssetListScenarios } from '@customer/store/apis/assetsApi';
import RefreshButton from '@customer/components/inputs/refresh-button/RefreshButton';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';
import { getHeatmapTag } from '@customer/store/apis/heatmapsApi';
import { useMemo } from 'react';
import { TagDescription } from '@reduxjs/toolkit/query';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  { type: QueryTag.Asset, id: 'LIST' },
  { type: QueryTag.Metadata, id: 'VEHICLEGROUPS' },
  QueryTag.ScenariosStat,
  QueryTag.ScenariosTimeSeries,
  {
    type: QueryTag.InteractionsSummary,
    id: AssetListScenarios.PerformanceVehicleInteractions,
  },
  {
    type: QueryTag.InteractionsSummary,
    id: AssetListScenarios.PerformanceGeofenceInteractions,
  },
  getHeatmapTag('GI'),
  getHeatmapTag('VI'),
];

export function Performance() {
  const { t } = useTranslation();

  const tabs = useMemo<NavTabModel[]>(() => {
    const performanceTabs: NavTabModel[] = [
      {
        title: t('VehicleInteractions'),
        to: '/performance/vehicle-interactions',
      },
      {
        title: t('GeofenceInteractions'),
        to: '/performance/geofence-interactions',
      },
    ];

    return performanceTabs;
  }, [t]);

  return (
    <Page
      header={
        <div className={styles.header}>
          <span>{t('CasPerformance')}</span>
          <RefreshButton tagsToClear={tagsToClearOnRefresh} />
        </div>
      }
      nav={<NavTabs tabs={tabs} hasBorder />}
    >
      <Outlet />
    </Page>
  );
}

export default Performance;
